const EMPTY_STRING = /^\s*$/;
const IPV4 = /^(\d{1,3}\.){3}\d{1,3}$/;
const LOCAL_HOSTNAME = /^(localhost|127(\.\d{1,3}){3}|::1|.+\.local)$/i;
const DEFAULT_MESSAGES = {
  presence: "can't be blank",
  format: 'is invalid',
  url: 'is not a valid url',
};

function isDefined(value) {
  return value !== null && value !== undefined;
}

function isEmpty(value) {
  if (!isDefined(value)) return true;
  if (typeof value === 'string') return EMPTY_STRING.test(value);
  if (Array.isArray(value)) return value.length === 0;
  if (value instanceof Date) return false;
  if (typeof value === 'object') return Object.keys(value).length === 0;
  return false;
}

function isLocalHost(hostname) {
  if (LOCAL_HOSTNAME.test(hostname)) return true;
  const m = hostname.match(IPV4);
  if (!m) return false;
  const [a, b] = hostname.split('.').map(Number);
  if (a === 10) return true;
  if (a === 192 && b === 168) return true;
  if (a === 172 && b >= 16 && b <= 31) return true;
  return false;
}

function presence(value, options) {
  const allowEmpty = options.allowEmpty === true;
  const fail = !isDefined(value) || (!allowEmpty && isEmpty(value));
  return fail ? (options.message || DEFAULT_MESSAGES.presence) : null;
}

function format(value, options) {
  if (isEmpty(value)) return null;
  if (typeof value !== 'string') return options.message || DEFAULT_MESSAGES.format;
  const pattern = options.pattern instanceof RegExp
    ? new RegExp(options.pattern.source, options.pattern.flags.replace(/[gy]/g, ''))
    : new RegExp(options.pattern, (options.flags || '').replace(/[gy]/g, ''));
  const match = pattern.exec(value);
  if (!match || match[0].length !== value.length) {
    return options.message || DEFAULT_MESSAGES.format;
  }
  return null;
}

function url(value, options) {
  if (isEmpty(value)) return null;
  if (typeof value !== 'string') return options.message || DEFAULT_MESSAGES.url;
  const message = options.message || DEFAULT_MESSAGES.url;
  const schemes = options.schemes || ['http', 'https'];
  const allowLocal = options.allowLocal === true;

  let parsed;
  try {
    parsed = new URL(value);
  } catch (_) {
    return message;
  }
  const scheme = parsed.protocol.replace(/:$/, '').toLowerCase();
  if (!schemes.includes(scheme)) return message;
  const hostname = parsed.hostname;
  if (!hostname) return message;
  if (!allowLocal && isLocalHost(hostname)) return message;
  const isIpv4 = IPV4.test(hostname);
  const isIpv6 = hostname.includes(':');
  if (!isIpv4 && !isIpv6 && !hostname.includes('.')) return message;
  return null;
}

const VALIDATORS = { presence, format, url };

function runConstraints(value, constraints) {
  const errors = [];
  for (const name of Object.keys(constraints)) {
    const validator = VALIDATORS[name];
    if (!validator) {
      throw new Error(`Unknown validator: ${name}`);
    }
    const msg = validator(value, constraints[name]);
    if (msg) errors.push(msg);
  }
  return errors;
}

function validate(attributes, constraints) {
  const input = attributes || {};
  const result = {};
  for (const field of Object.keys(constraints)) {
    const fieldErrors = runConstraints(input[field], constraints[field]);
    if (fieldErrors.length) result[field] = fieldErrors;
  }
  return Object.keys(result).length ? result : undefined;
}

validate.single = function single(value, constraints) {
  const errors = runConstraints(value, constraints);
  return errors.length ? errors : undefined;
};

export default validate;
